export const sortingStateToSortDtoArray = (sortingState) => sortingState.map((sorting) => ({
    direction: sorting.direction,
    field: sorting.fieldName,
}));
export const sortDtoToSortingState = (sortDtoArray) => sortDtoArray.map(({ field, direction }) => ({
    fieldName: field,
    direction: direction,
}));
//# sourceMappingURL=sortMapper.js.map